"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.colorOptions = exports.colorMappings = exports.breakpoints = void 0;
var breakpoints = {
  xxs: "382px",
  xs: "400px",
  s: "600px",
  m: "767px",
  l: "993px",
  xl: "1000px",
  xxl: "1400px",
  xsMUI: "400px",
  smMUI: "600px",
  mMUI: "767px",
  mdMUI: "960px",
  lMUI: "993px",
  lgMUI: "1280px",
  xlMUI: "1000px",
  xxlMUI: "1500px"
};
exports.breakpoints = breakpoints;
var colorMappings = {
  cream: 'var(--bf-core-cream)',
  yellow: 'var(--bf-core-yellow)',
  pink: 'var(--bf-core-pink)',
  teal: 'var(--bf-core-teal)',
  white: 'var(--bf-core-white)',
  black: 'var(--bf-core-black)',
  darkTeal: 'var(--bf-core-dark-teal)',
  gray: 'var(--bf-core-gray)',
  lightestTeal: 'var(--bf-lightest-teal)',
  lighterTeal: 'var(--bf-lighter-teal)',
  darkCream: 'var(--bf-dark-cream)',
  darkYellow: 'var(--bf-dark-yellow)',
  darkOrange: 'var(--bf-dark-orange)',
  darkPink: 'var(--bf-dark-pink)',
  darkerTeal: 'var(--bf-darker-teal)',
  darkestTeal: 'var(--bf-darkest-teal)',
  darkGrey: 'var(--bf-dark-grey)',
  op15Gray: 'var(--bf-op15-core-gray)',
  op45Cream: 'var(--bf-op45-core-cream)',
  op70Black: 'var(--bf-op70-core-black)'
};
exports.colorMappings = colorMappings;
var colorOptions = ['cream', 'yellow', 'pink', 'teal', 'gray', 'white', 'black', 'lightestTeal', 'lighterTeal', 'darkCream', 'darkYellow', 'darkOrange', 'darkPink', 'darkTeal', 'darkerTeal', 'darkestTeal', 'darkGrey', 'op15Gray', 'op45Cream', 'op70Black'];
exports.colorOptions = colorOptions;